import {AfterViewInit, Component,  OnDestroy, Input, OnInit} from '@angular/core';
import {StreamsService}  from "../../../services/streams.service";
import {StreamProject} from "../../../interfaces";
 
import {domain, protocol} from '../../../config';


///getToken 
//streaming

@Component({
  selector: 'app-stream-settings-common',
  templateUrl: './stream-settings-common.component.html',
  styleUrls: ['./stream-settings-common.component.scss'],
})
export class StreamSettingsCommonComponent implements OnInit, OnDestroy{


   
  @Input() stream: StreamProject

 
  domain: any = {
    name: domain, protocol
  }

   constructor(  ){

  }

  checkedChange(event){


 }
 
  ngOnInit() { 
    
  }

  
   ngOnDestroy() { 
    
   }
 
   
  
}
